export function realRoutePresent(routes, real, depositMethod) {
    return routes.some(r => r.name === real.networkName
        && r.deposit_methods?.includes(depositMethod)
        && r.tokens?.some(t => t.symbol === real.tokenSymbol && t.status === 'active'));
}
